import { Button } from "@mui/material";

export default function ButtonConsultLogs({children, ...props}){
    return (
        <Button
        color="blueSys"
        sx={{ textTransform: "initial",backgroundColor: "#2C4992" }}
        variant="contained"
        {...props}
      >
        Consultar Logs
      </Button>
    )
}